import MyScheduleBetaBody from "Pages/MyScheduleBeta/Components/MyScheduleBetaBody";
import MyScheduleBetaHeader from "Pages/MyScheduleBeta/Components/MyScheduleBetaHeader";
import UnmarkedLectureBody from "Pages/MyScheduleBeta/Components/UnmarkedLectureBody";
import { ScheduleBetaProvider } from "Pages/MyScheduleBeta/Context/ScheduleBetaContext";
import { useMyScheduleBeta } from "Pages/MyScheduleBeta/Hooks/useMyScheduleBeta";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const MyScheduleBetaInner = () => {
  const { screen }: any = useWindowSize();
  const location = useLocation();
  const scheduleHook = useMyScheduleBeta();
  const { CallMyScheduleApi, isNotmarkedVisible, fullSchedules } = scheduleHook;

  // Fetch schedule data on initial mount, but skip if returning from
  // lecture-details and we already have cached schedule data in context.
  useEffect(() => {
    const returningFromDetails =
      (location.state as any)?.fromLectureDetails === true;
    const hasCachedData =
      fullSchedules && Object.keys(fullSchedules).length > 0;

    if (returningFromDetails && hasCachedData) {
      return; // keep the existing context data — no refetch needed
    }
    CallMyScheduleApi();
  }, []);

  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "batchTableContainer pt-0 pb-1 mt-2 pl-5"
          : "ml-0 mr-0"
      }
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Pinned top section keeping your original header */}
      <div
        style={{
          background: "#fff",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          padding: "12px 12px 0px 0px",
          height: isNotmarkedVisible ? "" : 170,
        }}
      >
        <MyScheduleBetaHeader />
      </div>

      {isNotmarkedVisible ? <UnmarkedLectureBody /> : <MyScheduleBetaBody />}
    </div>
  );
};

const MyScheduleBeta = () => {
  return (
    <ScheduleBetaProvider>
      <MyScheduleBetaInner />
    </ScheduleBetaProvider>
  );
};

export default MyScheduleBeta;
